import { Box, ImageProps, useTheme } from "@outschool/backpack";
import {
  Container,
  CurvedGradientSection,
} from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import HomePageBanner from "../Banners/HomePageBanner";
import VisualLinkGrid from "./VisualLinkGrid";

type VisualLinkGridType = {
  title: string;
  style: string;
  visualLinksCollection: {
    items: Array<{
      text: string;
      path: string;
      image: {
        url: string;
      };
    }>;
  };
};

export function GradientWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(180deg, #F0F3FF 0%, #FFFFFF 100%)`,
        backgroundSize: "100% 275px",
        backgroundRepeat: "no-repeat",
      }}
    >
      {children}
    </Box>
  );
}

export function CurvedWrapper({ children }: { children: React.ReactNode }) {
  return (
    <CurvedGradientSection topColor="#F0F3FF">{children}</CurvedGradientSection>
  );
}

export default function FeaturedCategoriesHomePage({
  isSSR = false,
  Banner,
  items,
  renderImage,
}: {
  items: Array<VisualLinkGridType>;
  isSSR?: boolean;
  Banner?: JSX.Element;
  renderImage?: (
    props: ImageProps,
    nextImage?: Record<string, string>
  ) => React.ReactElement;
}) {
  const isMobile = useIsMobile();

  const theme = useTheme();

  const showBanner = Banner && !isSSR;

  const firstContainerSx = {
    paddingY: 100,
    ...(!showBanner && { paddingBottom: 50 }),
    [theme.breakpoints.down("sm")]: {
      paddingY: 80,
      ...(!showBanner && { paddingBottom: 40 }),
    },
  };

  return (
    <>
      {!!items?.[0] && (
        <Container sx={firstContainerSx}>
          <VisualLinkGrid item={items[0]} renderImage={renderImage} />
        </Container>
      )}

      <Container
        fullBleed={isMobile}
        sx={{ paddingBottom: Banner || !isSSR ? 80 : 0 }}
      >
        {Banner ? (
          Banner
        ) : isSSR ? (
          <></>
        ) : (
          <HomePageBanner isFullWidth={true} />
        )}
      </Container>

      {!!items?.[1] && (
        <Container
          sx={{
            paddingBottom: isMobile ? 80 : 100,
            paddingTop: isMobile ? 80 : !isSSR ? 100 : 0,
          }}
        >
          <VisualLinkGrid item={items[1]} renderImage={renderImage} />
        </Container>
      )}
      {!!items?.[2] && (
        <Container fullBleed={isMobile}>
          <Box>
            <VisualLinkGrid item={items[2]} renderImage={renderImage} />
          </Box>
        </Container>
      )}
    </>
  );
}
